module.exports = __webpack_public_path__ + "img/adult-ballerine-grey_1.5b31d41f.jpg";